import {sortBy} from '@/helpers/utils';

export const gettersTypes = {
  currentLength: '[survey] current feed items count',
  questions: '[survey] current survey questions',
  dirtyTimetableFilters: '[survey] dirty timetable filters',
};

const getters = {
  [gettersTypes.currentLength]: (state) => {
    if (!state.feed || !state.feed.left.length) return undefined;
    return state.feed.length;
  },
  [gettersTypes.questions]: (state) => {
    if (!state.survey || !state.survey.survey_meta || !state.survey.survey_meta.length) return [];
    return sortBy(state.survey.survey_meta, 'index', true);
  },
  [gettersTypes.dirtyTimetableFilters]: (state) => {
    return Object.values(state.timetableFilters).some((f) => (Array.isArray(f) ? !!f.length : !!f));
  },
};

export default getters;
